import { saveAs } from "file-saver";

import * as Consts from "./utils.consts";

import { canvasToPng } from "./canvasToPng";
import { isMobile } from "./isMobile";
import { writePngToClipboard } from "./writePngToClipboard";

export const saveAction = async (
  enqueueSnackbar: any,
  canvas: HTMLCanvasElement
) => {
  const croppedFile = await canvasToPng(canvas);

  if (isMobile()) {
    canvas.toBlob(function (blob) {
      if (blob === null) return;

      try {
        saveAs(blob, "sdvor-kolerovka.png");
        enqueueSnackbar("Изображение сохранено.", {
          variant: "success",
          anchorOrigin: Consts.anchorOriginParams,
          autoHideDuration: Consts.hideDuration,
        });
      } catch (error) {
        enqueueSnackbar("Невозможно сохранить изображение.", {
          variant: "error",
          anchorOrigin: Consts.anchorOriginParams,
          autoHideDuration: Consts.hideDuration,
        });
      }
    });
  } else {
    try {
      writePngToClipboard(croppedFile);
      enqueueSnackbar("Изображение скопировано в буфер обмена.", {
        variant: "success",
        anchorOrigin: Consts.anchorOriginParams,
        autoHideDuration: Consts.hideDuration,
      });
    } catch (error) {
      enqueueSnackbar("Невозможно скопировать изображение в буфер обмена.", {
        variant: "error",
        anchorOrigin: Consts.anchorOriginParams,
        autoHideDuration: Consts.hideDuration,
      });
    }
  }
};
